import * as React from 'react';
import { BaseButton } from '../../../../BaseComponents';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../../theme';
import FullscreenPopup from './FullscreenPopup/FullscreenPopup';
import cn from 'classnames';

interface Props {
	open?: boolean;
	inline?: boolean;
	onClose?: () => void;
	correct?: boolean;
}

const PopupWrapper: React.FC<Props> = props => {
	const { t } = useTranslation('Passenger');
	const theme = useTheme('PassengerForm').PopupWrapper;

	if (props.inline) {
		return <>{props.children}</>;
	}

	return (
		<FullscreenPopup open={props.open}>
			<div className={theme.fields}>{props.children}</div>

			<div className={theme.controls}>
				<BaseButton variant="smallSecondary" onClick={props.onClose} className={theme.cancel}>
					{t('Cancel')}
				</BaseButton>

				<BaseButton
					variant="smallPrimary"
					onClick={props.onClose}
					disabled={!props.correct}
					className={cn(theme.confirm, { [theme.disabled]: !props.correct })}
				>
					{t('Confirm')}
				</BaseButton>
			</div>
		</FullscreenPopup>
	);
};

export default PopupWrapper;
